var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Web_1920_124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_1920_124",
    "data-name": "Web 1920 \\u2013 124",
    clipPath: "url(#clip-Web_1920_124)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_893",
    "data-name": "Group 893",
    transform: "translate(234.684 145.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2862",
    "data-name": "Path 2862",
    d: "M0,0H36.76L24.507,177.672H12.253Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2361",
    "data-name": "Rectangle 2361",
    width: 18.38,
    height: 18.38,
    transform: "translate(9.19 189.926)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(-56.464 13.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2863",
    "data-name": "Path 2863",
    d: "M149.649,79.647c-86.6,86.6-86.6,227.03,0,313.629s227.03,86.6,313.629,0,86.6-227.03,0-313.629-227.03-86.6-313.629,0Zm165.709,28.088c18.722,0,33.7,15.447,33.7,34.171s-15.447,34.171-33.7,34.171c-18.722,0-34.171-15.447-34.171-34.641,0-18.72,15.445-33.7,34.171-33.7Zm48.215,228.9a22.373,22.373,0,0,1-4.682,7.957c-12.17,12.64-27.15,20.127-44.94,20.127-8.424,0-16.385,0-24.809-1.4-13.573-1.871-30.9-18.722-28.554-36.512q2.807-18.255,5.616-36.512c3.745-21.064,7.49-42.6,11.235-63.662,0-1.4.467-2.808.467-4.212,0-8.895-2.808-12.17-11.7-13.107a93.961,93.961,0,0,1-11.235-1.871c-4.212-1.4-6.553-5.149-6.086-8.424.467-3.745,2.808-6.086,7.49-7.02a42.937,42.937,0,0,1,7.957-.467h64.6c7.957,0,12.64,3.745,12.64,11.7a93.981,93.981,0,0,1-2.341,19.66c-4.212,24.342-8.895,48.215-13.107,72.557-1.4,7.957-3.278,15.915-4.212,23.872a33.087,33.087,0,0,0,.937,11.7c1.4,5.149,5.149,7.957,10.3,7.49a43.192,43.192,0,0,0,12.64-3.745c3.278-1.4,6.086-3.745,9.361-4.682,5.62-1.874,9.832,1.4,8.428,6.55Z",
    transform: "translate(0 0)",
    fill: "#c3c3ce"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.0388adae.svg";
export { ForwardRef as ReactComponent };